export default "__VITE_ASSET__dcf47cdb__"